/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Automated_OnlyInputs */

const en_api_error_task_automated_only = /** @type {(inputs: Api_Error_Task_Automated_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity can only be created automatically.`)
};

const pt_br2_api_error_task_automated_only = /** @type {(inputs: Api_Error_Task_Automated_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade só pode ser criada automaticamente.`)
};

/**
* | output |
* | --- |
* | "This activity can only be created automatically." |
*
* @param {Api_Error_Task_Automated_OnlyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_automated_only = /** @type {((inputs?: Api_Error_Task_Automated_OnlyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Automated_OnlyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_automated_only(inputs)
	return pt_br2_api_error_task_automated_only(inputs)
});